import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { useNavigate, useParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/app-layout";
import DashboardTab from "./tabs/dashboard-tab";
import PanelsTab from "./tabs/panels-tab";
import UsersTab from "./tabs/users-tab";
import RequestsTab from "./tabs/requests-tab";
import { NavbarTab } from "src/components/layout/app-navbar";

const PanelScoutPage = () => {
  useSetPageTitle("Panel Scout");
  const navigate = useNavigate();
  const { tab } = useParams<{ tab?: string }>();

  const panelScoutTabs: NavbarTab[] = [
    {
      id: "",
      key: "dashboard",
      label: "Dashboard",
    },
    {
      id: "panels",
      key: "panels",
      label: "Panels",
    },
    {
      id: "users",
      key: "users",
      label: "Users",
    },
    {
      id: "requests",
      key: "requests",
      label: "Requests",
    },
  ];

  const validTabs = panelScoutTabs.map((t) => t.id);
  type TabType = (typeof validTabs)[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : "";

  const handleTabChange = (tabId: string) => {
    navigate(`/panel-scout${tabId ? `/${tabId}` : ""}`);
  };

  return (
    <AppLayout
      activePage="/panel-scout"
      navbarProps={{
        showBackButton: true,
        backPath: "/panel-scout",
        tabs: panelScoutTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)] overflow-hidden">
        {currentTab === "" && <DashboardTab />}
        {currentTab === "panels" && <PanelsTab />}
        {currentTab === "users" && <UsersTab />}
        {currentTab === "requests" && <RequestsTab />}
      </div>
    </AppLayout>
  );
};

export default PanelScoutPage;
